import { render, staticRenderFns } from "./CircleTagItem.vue?vue&type=template&id=659e09b7&scoped=true&"
import script from "./CircleTagItem.vue?vue&type=script&lang=js&"
export * from "./CircleTagItem.vue?vue&type=script&lang=js&"
import style0 from "./CircleTagItem.vue?vue&type=style&index=0&id=659e09b7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "659e09b7",
  null
  
)

export default component.exports